import { Col, FormGroup, FormLabel, Row } from 'react-bootstrap';
import { Props, RolesResponse } from './jobPostSkillForm.type';
import { useFindSkillsQuery } from 'service/recruiterQuery/recruiterQuery';
import Select from 'components/common/form/select/Select';
import MultiSelect from 'components/common/form/multiSelect/MultiSelect';
import { useMemo } from 'react';

function JobPostSkillsForm({ role }: Props) {
  const { data = {}, isLoading } = useFindSkillsQuery('');

  const rolesData = data as RolesResponse;
  const options = useMemo(() => {
    return rolesData.skills?.[role] || [];
  }, [role, rolesData]);
  return (
    <Row className="g-5">
      <Col xs={12}>
        <FormGroup className="text-start">
          <FormLabel htmlFor="role">Role</FormLabel>
          <Select name="role" id="role" options={rolesData.roles || []} />
        </FormGroup>
      </Col>
      <Col xs={12}>
        <FormGroup className="text-start">
          <FormLabel htmlFor="skills">Key Skills</FormLabel>
          <MultiSelect
            name="skills"
            id="skills"
            options={options}
            isDisabled={!role}
            isLoading={isLoading}
          />
        </FormGroup>
      </Col>
    </Row>
  );
}

export default JobPostSkillsForm;
